import { render, staticRenderFns } from "./AppMemberRegistration.vue?vue&type=template&id=3fa24ac8&"
import script from "./AppMemberRegistration.vue?vue&type=script&lang=js&"
export * from "./AppMemberRegistration.vue?vue&type=script&lang=js&"
import style0 from "./AppMemberRegistration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports